import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { Box, Flex } from "rebass";
import { StudioSession } from "../../../../State/studioSession";
import styled from "styled-components";
import { Button } from "MVVM/Components/Button";
import theme from "theme/themeThree";
import { Text } from "rebass/styled-components";
import { FaPlus, FaMinus } from "react-icons/fa6";

interface IAddCardProps {
  card: any;
  handleToggle: (card: any, isToggled: any) => Boolean;
  size?: number;
  handleModalClose?: any;
  isActive?: boolean;
  outsideControl?: boolean;
}

export const AddCard = ({
  card,
  handleToggle,
  // size,
  handleModalClose,
  isActive, // this enables control of the toggle from parents. whereas studio uses session state to control the toggle
  outsideControl = false,
}: IAddCardProps) => {
  const studioSession = useRecoilValue(StudioSession);

  const [isHovered, setIsHovered] = useState(false);

  const [checked, setChecked] = useState(
    studioSession.userActivated?.some((x: any) => x._id === card._id) ||
      isActive,
  );
  const handleChange = (nextChecked: any) => {
    const toggleAllowed = handleToggle(card, nextChecked);
    setIsHovered(false);

    if (toggleAllowed) {
      setChecked(nextChecked);
    } else {
      if (handleModalClose) {
        handleModalClose();
      }
    }
  };

  useEffect(() => {
    setChecked(
      studioSession.userActivated?.some((x: any) => x._id === card._id),
    );
  }, [studioSession]); //eslint-disable-line

  useEffect(() => {
    if (outsideControl) {
      setChecked(isActive);
    }
  }, [isActive]); //eslint-disable-line

  return (
    <Box
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <Button
        className="roundedFilled"
        size="tiny"
        flex={true}
        style={{
          minWidth: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "99px",
          transition: "none",
          padding: "0px 10px",
          backgroundColor: getBackgroundColor(isHovered, checked),
          color: getTextColor(isHovered, checked),
        }}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          handleChange(!checked);
        }}
      >
        <ButtonContents isHovered={isHovered} isEnabled={checked} />
      </Button>
    </Box>
  );
};

const getBackgroundColor = (isHovered: boolean, isEnabled: boolean) => {
  if (isHovered && isEnabled) {
    return theme.colors.alert;
  }
  if (isEnabled) {
    return theme.colors.navy;
  }

  return theme.colors.envy;
};

const getTextColor = (isHovered: boolean, isEnabled: boolean) => {
  if (isHovered && isEnabled) {
    return theme.colors.ice;
  }
  if (isEnabled) {
    return theme.colors.envy;
  }
  return theme.colors.ice;
};

const ButtonContents = ({
  isHovered,
  isEnabled,
}: {
  isHovered: boolean;
  isEnabled: boolean;
}) => {
  if (isEnabled && isHovered) {
    return <Flex>Remove</Flex>;
  }
  if (isEnabled) {
    return <Flex>Added</Flex>;
  }
  if (!isEnabled) {
    return (
      <Flex alignItems="center" justifyContent="center">
        <PlusIcon style={{ marginTop: "2px", height: "10px" }} />
        <Text variant="text.labelXSmall">Add</Text>
      </Flex>
    );
  }

  return <Flex>Added</Flex>;
};
const PlusIcon = styled(FaPlus)`
  width: 15px;
  height: 15px;
  color: ${theme.colors.ice};
`;

const MinusIcon = styled(FaMinus)`
  width: 15px;
  height: 15px;
  color: ${theme.colors.ice};
`;
